import { render, staticRenderFns } from "./SystemAlertList.vue?vue&type=template&id=51063598"
import script from "./SystemAlertList.vue?vue&type=script&lang=js"
export * from "./SystemAlertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports